/* istanbul ignore file */
import React from 'react';
import logo from 'assets/images/logo.svg';
import logoWhite from 'assets/images/logo-white.svg';
import { Box, Paper } from '@mui/material';

const ExtensionPageLayout = ({
  children,
  isWhiteLogo = false,
}: {
  children: React.ReactNode;
  isWhiteLogo?: boolean;
}) => {
  return (
    <Paper className="extension-layout" sx={{ ...(isWhiteLogo && { p: '0 !important' }) }}>
      {isWhiteLogo ? (
        <Box
          sx={(theme: any) => ({
            display: 'flex',
            alignItems: 'center',
            p: 2,
            background: theme.vars.palette.common.sidebarMenuBg,
          })}
        >
          <img src={logoWhite} width={100} alt="Syberry" />
        </Box>
      ) : (
        <img src={logo} width={100} className="mb-3 pb-2" alt="Syberry" />
      )}
      {children}
    </Paper>
  );
};

export default ExtensionPageLayout;
